import { render, staticRenderFns } from "./EvaluationProjectAdd.vue?vue&type=template&id=f6180d8c&scoped=true&"
import script from "./EvaluationProjectAdd.vue?vue&type=script&lang=ts&"
export * from "./EvaluationProjectAdd.vue?vue&type=script&lang=ts&"
import style0 from "./EvaluationProjectAdd.vue?vue&type=style&index=0&id=f6180d8c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6180d8c",
  null
  
)

export default component.exports